import { cx } from "class-variance-authority";
import type { ComponentProps } from "react";

export function Avatar({ className, ...props }: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 40 40"
			className={cx(className, "overflow-visible")}
			{...props}
		>
			<g filter="url(#glow)">
				<circle cx="20" cy="20" r="20" fill="white" />
			</g>
		</svg>
	);
}
